import { createAction, props } from '@ngrx/store';
export const deleteNotification = createAction('[Notifications Modal] Delete Notification', props());
export const markNotificationRead = createAction('[Notifications Modal] Mark Notification Read', props());
